import "./common"; // must come first

/**
 * Initialize invertable select boxes and checkbox groups.
 */
$(() => {
  console.log("invertable.ts");

  // Handle invertable <select> elements
  $("select.invertable").each(function () {
    const $formGroup = $(this).closest(".form-group");
    const $label = $formGroup.find("label");

    // Avoid adding multiple buttons if already initialized
    if ($label.find(".invert").length === 0) {
      $label.append(' <a class="btn btn-default btn-xs invert"><i class="fa fa-exchange"></i></a>');
    }
  });

  $(document).on("click", ".invert", function () {
    const $select = $(this).closest(".form-group").find("select");
    const selectedValues = $select.val() as string[] | string | null;
    if (!selectedValues) return;

    const newValues: string[] = [];

    $select.find("option").each(function () {
      const val = $(this).val() as string;
      if (Array.isArray(selectedValues)) {
        if (!selectedValues.includes(val)) newValues.push(val);
      } else if (selectedValues !== val) {
        newValues.push(val);
      }
    });

    $select.val(newValues).trigger("change");
  });

  // Handle invertable checkbox groups
  $(".form-group.check_boxes.invertable").each(function () {
    const $label = $(this).find("label.control-label");
    if ($label.find(".invertcb").length === 0) {
      $label.append(' <a class="btn btn-default btn-xs invertcb"><i class="fa fa-exchange"></i></a>');
    }
  });

  $(document).on("click", ".invertcb", function () {
    $(this)
      .closest(".form-group")
      .find('input[type="checkbox"]')
      .each(function () {
        const $checkbox = $(this);
        $checkbox.prop("checked", !$checkbox.prop("checked")).trigger("change");
      });
  });
});
